export const isSlackPrompt = (prompt) => 'slackUserId' in prompt;
export const isAiConversationMessageComplete = (message) => 'response' in message && 'respondedAt' in message;
//# sourceMappingURL=types.js.map